import {Location} from './Location.model';
import {User} from './User.model';
import {SaleAdditionInformation} from './SaleAdditionInformation.model';
import {Photo} from './Photo.model';
import {Company} from './Company.model';

export class Sale {

  constructor(

    public id: number,
    public user: User,
    public company: Company,
    public sites: any,
    public cont_phone1: string,
    public cont_phone2: string,
    public fio: string,
    public price: number,
    public price_sqr: number,
    public auction: boolean,
    public exchange: string,
    public credit: boolean,
    public execution: boolean,
    public quickly: boolean,
    public contract: string,
    public contract_fraction: string,
    public contract_from: any,
    public contract_to: any,
    public request: boolean,
    public request_number: string,
    public location: Location,
    public number_flat: string,
    public room: number,
    public room_separate: number,
    public area: number,
    public area_leave: number,
    public area_kitchen: number,
    public wc: number,
    public roof: string,
    public balcony: number,
    public terrace: number,
    public level: number,
    public elite: boolean,
    public new_building: boolean,
    public free_layout: boolean,
    public storey: number,
    public storeys: number,
    public repair: number,
    public floor: number,
    public furniture: number,
    public comment: string,
    public sale: number,
    public send: boolean,
    public title: string,
    public text: string,
    public approved: boolean,
    public import_id: number,
    public source: number,
    public photo_reclame: Photo [],
    public photo_plan: Photo [],
    public photo_request: Photo [],
    public photo_inside: Photo [],
    public moderation: boolean,
    public delete_moderation: boolean,
    public delete_at: boolean,
    public created_at: Date,
    public updated_at: Date,
    public sale_addition_information: SaleAdditionInformation,
    public arraySites: any[] = [],
    public access_edit: boolean,
    public access_delete: boolean,
    public access_own_info: boolean,
    public access_reclame: boolean
  ) {}
}
